/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.notes', [])
    .controller('NotesAdminCtrl', NotesAdminCtrl);

  /** @ngInject */
  function NotesAdminCtrl($scope, $stateParams, UsersService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };

    load(1);

    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }

      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }
      UsersService.listNotes($stateParams.parentId, vm.oldPage, 25).then(success);

      function success(result){
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < result.results.length; i++) {
          result.results[i].ts = new Date(parseInt(result.results[i].ts.toString().substring(0, result.results[i].ts.toString().length - 3)));
        }
        vm.items = result.results;
      }
    }

    vm.pageChanged = function(newPage) {
      load(newPage);
    };

  }

})();
